var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMatic = function SvgMatic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8247E5",
    d: "M9.11 6.17a.54.54 0 0 0-.506 0l-1.18.695-.8.443-1.16.695a.54.54 0 0 1-.505 0l-.906-.548a.51.51 0 0 1-.252-.442V5.959a.52.52 0 0 1 .252-.442l.906-.527a.54.54 0 0 1 .506 0l.906.548a.51.51 0 0 1 .253.442v.696l.8-.464v-.716a.52.52 0 0 0-.253-.443l-1.685-.99a.54.54 0 0 0-.506 0L3.253 5.074A.46.46 0 0 0 3 5.496v1.98a.52.52 0 0 0 .253.442l1.706.99a.54.54 0 0 0 .506 0l1.159-.674.8-.463 1.159-.674a.54.54 0 0 1 .505 0l.906.527a.51.51 0 0 1 .253.442v1.053a.52.52 0 0 1-.253.443l-.885.526a.54.54 0 0 1-.505 0l-.906-.526a.51.51 0 0 1-.253-.443v-.674l-.8.464v.695a.52.52 0 0 0 .252.442l1.707.99a.54.54 0 0 0 .505 0l1.707-.99a.51.51 0 0 0 .253-.442V7.602a.52.52 0 0 0-.253-.442z"
  })));
};
export default SvgMatic;